import { render, staticRenderFns } from "./transvoid.vue?vue&type=template&id=510dd0be&"
import script from "./transvoid.vue?vue&type=script&lang=js&"
export * from "./transvoid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports